import { render, staticRenderFns } from "./CopyRule.vue?vue&type=template&id=ceea24d2"
import script from "./CopyRule.vue?vue&type=script&lang=js"
export * from "./CopyRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports